import { Formatter } from 'gf-ui';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';

const Select = ({ kid, domande, domanda, risposte, mostraSe, value, onChange }) => {

  const [visibile, mostra] = useState(false)

  const selVal = (val) => {
    onChange(kid, val)
  }

  useEffect(() => {
    if (mostraSe.length === 0) {
      mostra(true);
    } else {
      let mostraDomanda = [];
      Object.keys(mostraSe).forEach(idx => {
        const domanda_rif = mostraSe[idx];
        Object.keys(domande).forEach(id_domanda => {
          if (domanda_rif.ID_MA_CSS_D_R === parseInt(domande[id_domanda].val) && (domande[id_domanda]?.ARR_RISPOSTE?.find( r => Formatter.getBoolean(r.FLG_SELEZIONATA)) || false)) {
            mostraDomanda.push(true);
          }
        });
      })
      mostra(mostraDomanda.length === mostraSe.length)
    }
  }, [domande, mostraSe])

  return (
    <>
      {visibile && (
        <Form.Group className="mb-3 form-group">
          <Form.Label>{domanda}</Form.Label>
          <Form.Select
            aria-label={domanda}
            onChange={(e) => selVal(e.target.value)}
            value={value}
            className={`${(value !== undefined && value !== "") ? "is-valid" : ""}`}
            style={{ color: `${(value !== undefined && value !== "") ? "var(--bs-dark)" : "var(--bs-gray-500)"}` }}
            placeholder="Seleziona..."
            required >
            <option value="" style={{ color: "var(--bs-gray-500)" }}>Seleziona...</option>
            {Object.keys(risposte).map((risposta, index) =>
              <option key={index} value={risposte[risposta].ID_MA_CSS_D_R} className='text-dark'>{risposte[risposta].DESCRIZIONE}</option>
            )}
          </Form.Select>
        </Form.Group>
      )}
    </>
  )
}

export default Select;